import { useClientPortalAPI } from "@certn/api";
import { Card, Container, Loader, Divider, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export function ClientBillingProfileGroupsForm() {
  const { t } = useTranslation();
  const { billingProfileId } = useParams();

  const { data: billingProfile } = useClientPortalAPI(
    `/api/internal/client-portal/billing-profiles/${billingProfileId}/`
  );

  if (!billingProfile) {
    return <Loader />;
  }

  const groups = billingProfile.customergroup_set;

  if (!groups.length) {
    return (
      <Card className={styles.card}>
        <Container>
          <Text style="form/section-heading">{t("No groups assigned")}</Text>
        </Container>
      </Card>
    );
  }
  return (
    <Card className={styles.card}>
      <Container>
        <Text style="form/section-heading" className={styles.text}>
          {t("Assigned groups ({{numGroups}})", { numGroups: groups.length })}
        </Text>
        {groups.map((group, index) => (
          <Fragment key={`${group.id}-fragment`}>
            <Card hideBorder key={group.id} className={styles.subCard}>
              <Text style="form/body-primary">{group.name}</Text>
            </Card>
            {index !== groups.length - 1 && <Divider key={index} />}
          </Fragment>
        ))}
      </Container>
    </Card>
  );
}

const styles = {
  text: css({
    paddingBottom: "var(--space-2)",
  }),
  card: css({
    borderWidth: "var(--space-025)",
    borderRadius: "var(--border-radius-3)",
    padding: "var(--space-5)",
  }),
  subCard: css({
    paddingBottom: "var(--space-1)",
  }),
};
